import { useItemSet } from '@exam-management/common/item-set-provider';
import { useQBankStructure } from '@exam-management/qbs-provider';
import { useMemo } from 'react';

import { LocationFields } from '../../components';

export default function ItemSetLocationsPreview() {
  const { qBankStructureLevelItems, qBankStructureLevels } = useQBankStructure();
  const { itemSet } = useItemSet();

  // NOTE: this logic is duplicate a lot, please refactor it to utils
  const qBankStructureLevelWithoutFirstLevel = useMemo(
    () => qBankStructureLevels.filter((qBankStructureLevel) => qBankStructureLevel.level !== 1),
    [qBankStructureLevels],
  );

  const levelItems = useMemo(
    () =>
      qBankStructureLevelItems.filter((qbsLevelItem) =>
        itemSet.questionStructures.find((questionStructure) => {
          return qbsLevelItem.id === questionStructure.refLevelItemId;
        }),
      ),
    [qBankStructureLevels, qBankStructureLevelItems],
  );

  return (
    <LocationFields qbsLevelItems={levelItems} qbsLevels={qBankStructureLevelWithoutFirstLevel} />
  );
}
